import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { handleValidateObj } from 'constants/objValues/objvalues';

const SaleType = ({
  handleValue,
  documentUploadUrl,
  isSupply = false,
  agreementLength = null,
  isEditContract=false,
  prefilledData,
  isApartment
}) => {

  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth()+1; 
  var yyyy = today.getFullYear();
  if(dd<10) {
      dd='0'+dd;
  } 
  if(mm<10) {
      mm='0'+mm;
  } 
  today = dd+'-'+mm+'-'+yyyy;
  //console.log('pre+filled data - ' + JSON.stringify(prefilledData))  ;
  const salesTypeObject = {
    salesType: '',
    channelPartner: '',
    channelPartnerValue: '',
    contractTypePrefilled: { id: null, value: '' },
  };
  const [minDateIndex, setMinDateIndex] = useState(null);

  const [salesTypeData, setSalesTypeData] = useState(salesTypeObject);

  const [saleType, setSaleType] = useState('');
  const [saleTypeName, setSaleTypeName] = useState('');

  const handleSalesType = (val) => {
    setSaleType(val.id);
    setSaleTypeName(val.id);
      setSalesTypeData({
        ...salesTypeData,
        salesType: val.id,
        channelPartner: '',
        channelPartnerValue: '',
      });
  };
  //console.log('Sales Type Data - ' + JSON.stringify(salesTypeData));

  useEffect(() => {
    if (
      prefilledData?.commercial !== undefined &&
      prefilledData?.commercial !== null
    ) {
      const {
        type_of_sales,
        channel_partner,
        other_cp_name,
      } = prefilledData?.commercial;

      setTimeout(() => {
      setSalesTypeData({
        ...salesTypeData,
        salesType: type_of_sales,
        channelPartner:channel_partner,
        channelPartnerValue: other_cp_name
      }); 
      setSaleType(type_of_sales);
      }, 100);

    }
  }, [prefilledData]);


  const handleSalesTypeData = () => {
    if (saleType !== '' && saleType !== null) {
      handleValue({...salesTypeData});
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handleSalesTypeData();
  }, [saleType,salesTypeData]);

  console.log("SALES: ", salesTypeData)

  // useEffect(() => {
  //   if(salesTypeData.channelPartner !== 'Others')
  //   setSalesTypeData({
  //     ...salesTypeData,
  //     channelPartnerValue: '',
  //   });
  // }, [salesTypeData]);


  return (
    <Fragment>
      <FormSection title={localization.saleTypeHeading}>
          <DropDownInput
              data={[
                { name: 'Direct Sales', id: 'Direct Sales' },
                { name: 'PO to Vendor By Park+', id: 'PO to Vendor By Park+' },
                { name: 'PO by Vendor To Park+', id: 'PO by Vendor To Park+' },
                { name: 'Channel Partner', id: 'Channel Partner' },
                { name: 'Dealer with Service', id: 'Dealer with Service' },
                { name: 'Dealer without Service', id: 'Dealer without Service' }
              ]}
              label={localization.typeOfSales}
              required={isSupply ? false : true}
              isStarRequired={isSupply ? false : true}
              errorMsg={isSupply ? '' : localization.isRequired}
              getIdValue={(val) => handleSalesType(val)}
              value={salesTypeData?.salesType}
          />
          {(saleType === 'PO to Vendor By Park+' || saleType === 'PO by Vendor To Park+' ||
                    saleType === 'Channel Partner' || saleType === 'Dealer with Service' || saleType === 'Dealer without Service' ) &&
            <div className='row'>
              <div className='col-md-6'>
                <DropDownInput
                    data={[
                      { name: 'Golf automation', id: 'Golf automation' },
                      { name: 'Yash automation', id: 'Yash automation' },
                      { name: 'Dtrendz', id: 'Dtrendz' },
                      { name: 'Swaraj', id: 'Swaraj' },
                      { name: 'Raj Udyog', id: 'Raj Udyog' },
                      { name: 'Accurate', id: 'Accurate' },
                      { name: 'Others', id: 'Others' },
                    ]}
                    label={localization.channelPartner}
                    required={isSupply ? false : true}
                    isStarRequired={isSupply ? false : true}
                    errorMsg={isSupply ? '' : localization.isRequired}
                    getIdValue={(val) => {
                      setSalesTypeData({
                        ...salesTypeData,
                        channelPartner: val.id,
                        channelPartnerValue: '',
                      });
                      //handleRemoverValue('channelParter',val.id);        
                    }}
                    value={salesTypeData?.channelPartner}
                />
              </div>
              {salesTypeData.channelPartner === 'Others' &&
              <div className='col-md-6'>
              <ConstantInput
                handleChange={(val) =>
                  setSalesTypeData({ ...salesTypeData, channelPartnerValue: val })
                }
                type="text"
                label={localization.channelPartnerName}
                value={salesTypeData?.channelPartnerValue}
                isStarRequired={true}
                required
              />
              </div>
              }
            </div>
          }
      </FormSection>
      
    </Fragment>
  );
};

SaleType.propTypes = {
  handleValue: PropTypes.func,
  documentUploadUrl: PropTypes.func,
};

export default SaleType;
